import React, { Component } from 'react';
import MaintancePage from '@/components/BuilderIO/MaintancePage';

class ErrorBoundary extends Component {
  // eslint-disable-next-line react/state-in-constructor, react/no-unused-state
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <MaintancePage />;
    }
    return (this.props as any).children;
  }
}
export default ErrorBoundary;
